import React from 'react';
import Button from '../common/ui-components/input/Button';
import styles from '../../styles/modules/components/SelfServe/no-plan-found.module.scss';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { ContactUs } from './ContactUsModal'
import { getCustomerCookie } from '../../api/cookies';
import Cookies from 'js-cookie';
import { SignOut } from '../../api/myaccount';
import { setIsAuthenticate } from '../../redux/actions/customerActions';
import { connect } from 'react-redux';
import { raiseSrPageViewed } from '../../tracking/segment/loginPage';


interface MainProps{
    subIssues: any,
    header:string,
    subTextOne:string,
    buttonOneText:string,
    urlDestination:string,
    setIsAuthenticate : any,
    selfserveReducer?: any

}

const NoPlanFound1 = (props: MainProps) => {
    const router = useRouter()
    useEffect(() => {
        window.scrollTo({top:0,left:0,'behavior': 'smooth'});
        if(!(props.selfserveReducer?.userPlans?.length>0)){
            raiseSrPageViewed({'active_sr_ids':'no plan found'})
        }        
    }, [])
    const [writeToUs, setWriteToUs] = useState(false);
    return (
        <React.Fragment>
        <div className={styles.no_plan_found}>

            <h3>{props.header}</h3>
            <h5>{props.subTextOne}</h5>

            <Button      
                className={`${styles.mobile_btn} ${styles.primary_btn}`} 
                text={props.buttonOneText} 
                variant='primary'
                onClick={() => {
                    const customerCookie = getCustomerCookie()
                    
                    if(customerCookie){
                        SignOut().then(()=>{
                            props.setIsAuthenticate(false)   
                        }
                        )
                        Cookies.remove('customer_personal_details');
                        Cookies.remove('is_authenticate');
                    }
                    router.reload();
                }}
            />

            <p>or</p>

            <h5>Would you like to contact our Team for Support?</h5>

            <Button      
                className={styles.mobile_btn} 
                text={'Contact Us'} 
                variant='secondary'
                onClick={() => {setWriteToUs(true)}}
            />

        </div>
            <ContactUs is_open={writeToUs} closeModal={setWriteToUs} subIssues={props.subIssues} />
        </React.Fragment>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setIsAuthenticate: (data: any) => dispatch(setIsAuthenticate(data)),
    };
  };

export default connect(null, mapDispatchToProps)(NoPlanFound1)
